<template lang="pug">
div(v-if="!game")
  p no game selected

v-container(v-else fluid grid-list-md pa-0)
  game-panel(:game="game")

  v-divider

  v-tabs.game-editor-tabs(v-model="editorTab" background-color="transparent")
    v-tab(title="Template Editor")
      v-icon layers
    v-tab(title="Data Editor")
      v-icon mdi-table-edit

  v-divider

  v-tabs-items(v-model="editorTab")
    v-tab-item
      v-layout.component-section(row)
        v-flex.sidebar-panel(:class="sidebarOpen ? 'sidebar-open' : 'sidebar-collapsed'")
          v-btn.sidebar-toggle(icon small @click="sidebarOpen = !sidebarOpen" :title="sidebarOpen ? 'Collapse sidebar' : 'Expand sidebar'")
            v-icon {{ sidebarOpen ? 'chevron_left' : 'chevron_right' }}
          component-panel(v-show="sidebarOpen" :components="findAllGameComponents(game)")
        v-flex.active-component
          component-editor(v-if="activeComponent" :component="activeComponent")
          .pa-6.text-center.grey--text(v-else)
            v-icon(large color="grey lighten-2") layers
            .subtitle-2.mt-2 No Component Selected

    v-tab-item
      realtime-editor(:game="game" :components="findAllGameComponents(game)" :active="editorTab === 1")
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'

  import GamePanel from './GamePanel.vue'
  import ComponentPanel from '../component/ComponentPanel.vue'
  import ComponentEditor from '../component/ComponentEditor.vue'
  import RealtimeEditor from '../realtime/RealtimeEditor.vue'

  export default {
    props: ['gameId'],

    data() {
      return {
        sidebarOpen: true,
        editorTab: 0,
      }
    },

    mounted() {
      console.log('[GameEditor] mounted, gameId:', this.gameId)
      console.log('[GameEditor] Store games:', Object.keys(this.$store.state.games.games))
      if (this.game) {
        this.ensureFontsFetchedForGame(this.game)
      }
    },

    components: { GamePanel, ComponentPanel, ComponentEditor, RealtimeEditor },

    computed: {
      ...mapGetters([
        'findAllGameComponents',
        'activeComponent',
        "findGame"
      ]),

      game() {
        const g = this.findGame(this.gameId, false)
        console.log('[GameEditor] game computed, gameId:', this.gameId, 'found:', g)
        return g
      }
    },

    methods: mapActions([ 'ensureFontsFetchedForGame' ])
  }
</script>

<style>
/* Spreadsheet-style tab strip */
.game-editor-tabs .v-tabs-bar {
  height: 34px;
}

.game-editor-tabs .v-tabs-slider-wrapper {
  display: none;
}

.game-editor-tabs .v-tab {
  border-radius: 4px 4px 0 0;
  border-left:   1px solid transparent;
  border-top:    1px solid transparent;
  border-right:  1px solid transparent;
  border-bottom: none;
  margin-right: 3px;
  min-width: 85px;
  padding: 0 27px;
  position: relative;
  bottom: -1px;
  opacity: 1 !important;
  letter-spacing: 0;
}

.theme--light .game-editor-tabs .v-tab {
  background: rgba(0,0,0,0.05);
  border-color: rgba(0,0,0,0.15);
  color: rgba(0,0,0,0.45);
}
.theme--light .game-editor-tabs .v-tab--active {
  background: #ffffff;
  border-color: rgba(0,0,0,0.2);
  color: rgba(0,0,0,0.87);
}

.theme--dark .game-editor-tabs .v-tab {
  background: rgba(255,255,255,0.05);
  border-color: rgba(255,255,255,0.12);
  color: rgba(255,255,255,0.4);
}
.theme--dark .game-editor-tabs .v-tab--active {
  background: #1e1e1e;
  border-color: rgba(255,255,255,0.25);
  color: #ffffff;
}
</style>

<style scoped>
.sidebar-panel {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  overflow-y: auto;
  overflow-x: hidden;
  transition: width 0.2s ease, min-width 0.2s ease, max-width 0.2s ease;
  border-right: 1px solid rgba(0,0,0,0.12);
}
.theme--dark .sidebar-panel { border-right-color: rgba(255,255,255,0.12); }
.sidebar-open {
  width: 180px;
  min-width: 180px;
  max-width: 180px;
}
.sidebar-collapsed {
  width: 36px;
  min-width: 36px;
  max-width: 36px;
}
.sidebar-toggle {
  display: block;
  padding: 4px;
  flex-shrink: 0;
}
.active-component {
  flex: 1 1 0;
  min-width: 0;
}
</style>
